import React, { useState } from "react";
import { useFormik } from "formik";
import { connect } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import * as Yup from "yup";
import { injectIntl } from "react-intl";
import * as auth from "../../store/ducks/auth.duck";
import { requestPassword } from "../../crud/auth.crud";
import { TextField, Grid } from "@material-ui/core";
import { Button, Alert, Container } from "react-bootstrap";
import { values } from "lodash-es";

const initialValues = {
  email: "",
};

function ForgotPassword(props) {
  const { intl } = props;
  const history = useHistory();
  const [isRequested, setIsRequested] = useState(false);

  const ForgotPasswordSchema = Yup.object().shape({
    email: Yup.string()
      .email("Wrong email format")
      .min(3, "Minimum 3 symbols")
      .max(50, "Maximum 50 symbols")
      .required(
        intl.formatMessage({
          id: "AUTH.VALIDATION.REQUIRED_FIELD",
        })
      ),
  });

  const formik = useFormik({
    initialValues,
    validationSchema: ForgotPasswordSchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      requestPassword(values.email)
        .then(() => setIsRequested(true))
        .catch(() => {
          setIsRequested(false);
          setSubmitting(false);
          setStatus(
            intl.formatMessage(
              { id: "AUTH.VALIDATION.NOT_FOUND" },
              { name: values.email }
            )
          );
        });
    },
  });

  if (isRequested) {
return (
  <div className="kt-login__body">
    <div className="login-form login-forgot" style={{ display: "block" }}>
      <div className="text-center mb-10 mb-lg-20"></div>

      <div
        role="alert"
        className="custom-alert"
      >
        <div className="alert-text">
          <i className="fas fa-info-circle text-info mr-2"></i>
          Temporary password sent. Please check your inbox (and spam folder).
        </div>

        <div className="alert-button-container">
          <Button
            type="button"
            id="kt_login_forgot_cancel"
            variant="primary"
            onClick={() => history.push("/auth/login")}
          >
            Login
          </Button>
        </div>
      </div>
    </div>
  </div>
);

  }

  return (
    <div className="kt-login__body">
      <div className="login-form login-forgot" style={{ display: "block" }}>
        <div className="text-center mb-10 mb-lg-20">
          <h3 className="font-size-h1">Forgotten Password?</h3>
          <div className="text-muted font-weight-bold">
            Enter your email (or username) to reset your password
          </div>
        </div>
        <form
          onSubmit={formik.handleSubmit}
          className="form fv-plugins-bootstrap fv-plugins-framework animated animate__animated animate__backInUp"
        >
          {formik.status && (
            <div className="mb-10 alert alert-custom alert-light-danger alert-dismissible">
              <div className="alert-text font-weight-bold">
                {formik.status}
              </div>
            </div>
          )}

          <div className="form-group">
            <TextField
              variant="outlined"
              type="email"
              label="Email (or username)"
              margin="normal"
              className="kt-width-full"
              inputProps={{ style: { backgroundColor: "white" } }}
              name="email"
              value={formik.values.email}
              onChange={formik.handleChange}
              helperText={formik.touched.email && formik.errors.email}
              error={Boolean(formik.touched.email && formik.errors.email)}
              fullWidth
            />
          </div>

          <div className="form-group d-flex flex-wrap flex-center">
            <Grid container direction="row" justifyContent="space-between">
              <Grid item md={3}>
                <Link to="/auth">
                  <Button
                    type="button"
                    id="kt_login_forgot_cancel"
                    variant="secondary"
                  >
                    Cancel
                  </Button>
                </Link>
              </Grid>
              <Grid item md={3}>
                <Button
                  id="kt_login_forgot_submit"
                  type="submit"
                  variant="primary"
                  disabled={formik.isSubmitting}
                >
                  Submit
                </Button>
              </Grid>
            </Grid>
          </div>
        </form>
      </div>
    </div>
  );
}

export default injectIntl(connect(null, auth.actions)(ForgotPassword));
